import { jsx as _jsx } from "react/jsx-runtime";
export var Wrapper = function (_a) {
    var children = _a.children;
    return (_jsx("div", { className: "c-wrapper", children: _jsx("div", { className: "u-max-width-710 u-margin-auto", children: _jsx("div", { className: "c-inner-wrapper u-pt", children: children }) }) }));
};
